import { render, staticRenderFns } from "./BaseSwiper.vue?vue&type=template&id=3de70435&scoped=true"
import script from "./BaseSwiper.vue?vue&type=script&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&lang=js"
import style0 from "./BaseSwiper.vue?vue&type=style&index=0&id=3de70435&prod&scoped=true&lang=scss"
import style1 from "./BaseSwiper.vue?vue&type=style&index=1&id=3de70435&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de70435",
  null
  
)

export default component.exports